/**
*
*   Content Block
*       - A left/right content block + image or video
*
**/
'use client';

import Config from '@/config';
import Image from '@/components/image';
import Button from '@/components/button';
import { useState, useRef } from 'react';
//import { gsap } from 'gsap';
//import { useGSAP } from '@gsap/react';
//import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { useLocale, useTranslations } from 'next-intl';

//Load Module
//gsap.registerPlugin(useGSAP);
//gsap.registerPlugin(ScrollTrigger);

//Build the Element
export default function Quote({ product, ...props }){

    const ref = useRef();
    const t = useTranslations();
/*
    //On Mount
    useGSAP(() => {

        //Skip if it hasn't loaded
        if( !ref.current ) return;

        //Prepare the MatchMedia
        let mm = gsap.matchMedia();

        //Set Variables
        const $section  = ref.current;

        //
        mm.add('(max-width: 750px)', context => {

            //Create Timeline
            let timeline = gsap.timeline({
                scrollTrigger: {
                    trigger:                $section,
                    invalidateOnRefresh:    true,
                    scrub:                  true,
                    pin:                    false,
                    markers:                false,
                    once:                   true,
                    start:                  '-150% left',
                    end:                    '-50% left',
                },
            });

            timeline.fromTo( $section , { xPercent:120 },{ xPercent:0 });

        });

    }, { scope: ref.current });
*/
    //Return
    return (
        <blockquote id="quote" ref={ ref }>
            <svg xmlns="http://www.w3.org/2000/svg" width="51" height="50" viewBox="0 0 51 50" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M43.7373 38.0084C44.153 37.3047 44.8225 36.7767 45.6227 36.5222C48.5395 35.5939 50.5 32.9132 50.5 29.8529C50.5 27.8656 49.6492 25.9644 48.166 24.6362C47.7235 24.2395 47.5715 23.623 47.7705 23.028C47.9628 22.4536 48.0598 21.853 48.0598 21.2433C48.0598 19.0454 46.7708 17.0264 44.7755 16.0999C44.2286 15.8459 43.8844 15.2966 43.899 14.7009C43.9119 14.1522 43.8423 13.5992 43.6921 13.056C43.0964 10.9003 41.2959 9.29382 39.1053 8.96362C37.4482 8.71643 35.7826 9.19067 34.5283 10.2692C33.274 11.3489 32.5544 12.9169 32.5544 14.5886C32.5551 15.2356 32.1748 15.8337 31.5846 16.1127C29.6095 17.0459 28.3333 19.0601 28.3333 21.2433C28.3333 21.853 28.4303 22.4536 28.6226 23.0273C28.8215 23.623 28.6696 24.2395 28.2271 24.6362C26.7439 25.9644 25.8931 27.8656 25.8931 29.8529C25.8931 32.9486 27.8816 35.6378 30.8418 36.5448C31.6499 36.792 32.3298 37.3224 32.7571 38.0371C33.8142 39.8055 35.6001 40.9178 37.6136 41.1116V48.75H14.4844V26.6901C21.5603 26.3604 27.2194 20.5172 27.2194 13.3612C27.2194 5.99365 21.2263 0 13.8594 0C6.49304 0 0.5 5.99365 0.5 13.3612C0.5 20.5172 6.1591 26.3604 13.2344 26.6901V48.75H1.125C0.779541 48.75 0.5 49.0295 0.5 49.375C0.5 49.7205 0.779541 50 1.125 50H49.8744C50.2198 50 50.4994 49.7205 50.4994 49.375C50.4994 49.0295 50.2198 48.75 49.8744 48.75H38.8636V41.1101C40.8697 40.9094 42.6995 39.7654 43.7373 38.0084ZM1.75182 13.3609C1.75182 6.68301 7.18395 1.24966 13.8612 1.24966C20.5384 1.24966 25.9712 6.68301 25.9712 13.3609C25.9712 19.8277 20.8723 25.1114 14.4862 25.4398V21.0717C19.1006 20.7741 22.7662 16.9516 22.7662 12.2824C22.7662 11.9369 22.4867 11.6574 22.1412 11.6574C21.7958 11.6574 21.5162 11.9369 21.5162 12.2824C21.5162 16.262 18.4111 19.5271 14.4862 19.8217V9.3472C14.4862 9.00174 14.2067 8.7222 13.8612 8.7222C13.5157 8.7222 13.2362 9.00174 13.2362 9.3472V15.1352C9.87427 14.8583 7.2224 12.0525 7.2224 8.63736C7.2224 8.2919 6.94286 8.01236 6.5974 8.01236C6.25194 8.01236 5.9724 8.2919 5.9724 8.63736C5.9724 12.7415 9.18484 16.1048 13.2362 16.3852V25.4398C6.85016 25.1114 1.75182 19.8277 1.75182 13.3609ZM31.2098 35.3498C32.3139 35.6879 33.2453 36.4149 33.8318 37.3963C34.6612 38.7832 36.0462 39.6733 37.6154 39.8616V29.5907C34.5396 29.3113 32.121 26.7313 32.121 23.5963C32.121 23.2508 32.4006 22.9713 32.746 22.9713C33.0915 22.9713 33.371 23.2508 33.371 23.5963C33.371 26.0412 35.23 28.0603 37.6154 28.3343V22.9597C37.6154 22.6142 37.895 22.3347 38.2404 22.3347C38.5859 22.3347 38.8654 22.6142 38.8654 22.9597V31.6512C41.454 31.3969 43.4827 29.2194 43.4827 26.5784C43.4827 26.233 43.7623 25.9534 44.1077 25.9534C44.4532 25.9534 44.7327 26.233 44.7327 26.5784C44.7327 29.9083 42.1435 32.6422 38.8654 32.9011V39.8602C40.4307 39.6652 41.8486 38.7509 42.6624 37.3725C43.2349 36.4039 44.1517 35.6788 45.2454 35.3309C47.6417 34.5686 49.2518 32.367 49.2518 29.853C49.2518 28.2209 48.5529 26.6584 47.334 25.5677C46.5259 24.8438 46.233 23.6915 46.587 22.6319C46.7359 22.1851 46.8116 21.7182 46.8116 21.2434C46.8116 19.5301 45.8063 17.956 44.2512 17.234C43.2532 16.7701 42.6252 15.7642 42.6508 14.6717C42.6612 14.2457 42.6063 13.8141 42.4891 13.3893C42.0319 11.7341 40.5976 10.4523 38.921 10.2003C38.686 10.1649 38.4516 10.1472 38.2209 10.1472C37.1613 10.1472 36.1597 10.5158 35.3455 11.2165C34.3671 12.0588 33.8062 13.2813 33.8062 14.571C33.808 15.716 33.1458 16.7585 32.1198 17.2431C30.5799 17.9706 29.585 19.5411 29.585 21.2434C29.585 21.7182 29.6607 22.1851 29.8096 22.6313C30.1636 23.6915 29.8707 24.8438 29.0626 25.5677C27.8437 26.6584 27.1448 28.2209 27.1448 29.853C27.1448 32.3957 28.7781 34.6046 31.2098 35.3498Z" fill="white"/>
            </svg>
            <q>{ t('Pages.Product.Quote.text') }</q>
            <cite>Katie Derrick, Founder</cite>
        </blockquote>
    );

}